<template>
    <v-app id="Belit" :dark="dark">

        <!------------------------------->
        <!---------GLOBAL CLOAK---------->
        <!------------------------------->
            <!------------------------------->
            <!--------HEADER TOOLBAR--------->
            <!------------------------------->
            <v-app-bar
                    :clipped-left="true"
                    app
            >
                <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
                <v-toolbar-title>{{ title }} {{$store.state.testing ? '=== TESTING ===' : ''}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <CustomerSearchBar v-if="name"></CustomerSearchBar>
                <v-spacer></v-spacer>
                <v-avatar
                        v-if="name"
                        :size="40"
                        color="grey lighten-4"
                >
                    <img :src="avatar" alt="avatar">
                </v-avatar>
                <v-menu bottom v-if="name">
                    <template v-slot:activator="{on}">
                        <v-btn
                                v-on="on"
                                text
                        >
                            {{ name }}
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item href="#">
                            <v-list-item-title>
                                <span>Settings</span>
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="googleLogOut">
                            <v-list-item-title>
                                <span>Log Off</span>
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-app-bar>
            <!------------------------------->
            <!--LEFT SIDE NAVIGATION DRAWER-->
            <!------------------------------->
            <v-navigation-drawer
                    v-model="drawer"
                    clipped
                    app
                    expand-on-hover
                    permanent
            >
                <v-list  v-if="$store.getters.id">
                  <CreateCustomer>
                    <template v-slot:activator="{on}">
                      <v-list-item v-on="on">
                        <v-icon>add</v-icon>
                        <v-list-item-title>Create Customer</v-list-item-title>
                      </v-list-item>
                    </template>
                  </CreateCustomer>
                    <template v-for="(route, index) in $router.options.routes">
                        <template v-if="route.meta && route.meta.badge">
                            <v-list-item :to="route.path" v-if="!route.hideFromNav && !route.testing && !(route.hideWhileTesting && $store.state.testing)" :key="index">
                              <v-badge color="error" left overlap :value="$store.state.notifications[route.meta.badge.notification]" :content="$store.state.notifications[route.meta.badge.notification]">
                              <v-icon>{{route.icon}}</v-icon>
                              </v-badge>
                              <v-list-item-title>
                                {{route.name}}
                              </v-list-item-title>
                            </v-list-item>
                        </template>
                        <template v-else>
                          <v-list-item :to="route.path" v-if="!route.hideFromNav && !route.testing && !(route.hideWhileTesting && $store.state.testing)" :key="index">
                            <v-icon>{{route.icon}}</v-icon>
                            <v-list-item-title>
                              {{route.name}}
                            </v-list-item-title>
                          </v-list-item>
                        </template>
                    </template>
                  <v-list-group v-if="$router.options.routes.some(route => route.testing)">
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>TESTING NAVS</v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <template v-for="(route, index) in $router.options.routes">
                      <v-list-item :to="route.path" v-if="route.testing" :key="index">
                        <v-icon>{{route.icon}}</v-icon>
                        <v-list-item-title>
                          {{route.name}}
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-list-group>
                </v-list>
            </v-navigation-drawer>
            <!------------------------------->
            <!---------ERROR/SUCCESS MESSAGES (post/get--------->
            <!------------------------------->
            <v-snackbar
                    :color="$store.state.snackBar.type"
                    v-model="showMessage"
                    multi-line="multi-line"
                    :timeout="$store.state.snackBar.delay"
                    top="top"
            >
                {{ $store.state.snackBar.message }}
                <v-btn
                        color="black"
                        text
                        @click="$store.commit('resetSnackBar')"
                >
                    Close
                </v-btn>
            </v-snackbar>
          <v-snackbar
              v-model="showLoading"
              multi-line="multi-line"
              :timeout="-1"
              top="top"
          >
            {{ $store.state.snackBar.loadingMessage }}
            <br>
            <v-progress-linear :indeterminate="true"></v-progress-linear>
          </v-snackbar>
            <!------------------------------->
            <!---------BODY CONTENTS--------->
            <!------------------------------->
            <v-main app>
                <v-container class="fill-height" fluid>
<!--                    <v-fade-transition hide-on-leave>-->
                        <router-view></router-view>
<!--                    </v-fade-transition>-->
                </v-container>
            </v-main>
            <!------------------------------->
            <!----------FOOTER BAR----------->
            <!------------------------------->
            <v-footer
                    id="app_footer"
                    fixed
                    app
            >
                <v-layout>
                    <v-spacer></v-spacer>
                    <v-flex>
                        <span>&copy; {{ new Date().getFullYear() }}, Confidence Analytics</span>
                    </v-flex>
                    <v-spacer></v-spacer>
                </v-layout>
            </v-footer>
    </v-app>
</template>
<script>
    import firebase from 'firebase/app'
    import Label from "@/Lib/LabelPrinterV2";
    // import belitSearch from './components/BelitSearch'
    export default {
        name: 'App',
        components: {
          CustomerSearchBar: () => import("@/components/general/CustomerSearchBar"),
          CreateCustomer: () => import("@/views/Directory/components/CreateCustomer")
        },
        computed: {
            name() {
                return this.$store.state.user.name
            },
            avatar() {
                return this.$store.state.user.picture
            },
            showLoading:{
              get(){
                return this.$store.state.snackBar.showLoading;
              },
              set(){
                this.$store.commit('resetLoadingSnackBar');
              }
            },
            showMessage:{
                get(){
                    return this.$store.state.snackBar.show;
                },
                set(){
                    this.$store.commit('resetSnackBar');
                }
            }
        },
        data() {
            return {
                title: process.env.VUE_APP_TITLE_BAR,
                dark: false,
                drawer: false,
                selectedCustomer: null,
                route_notifications:{},
            }
        },
        created(){
            this.$store.$db().model("users").load();
            this.$store.$db().model("sampleCertTypes").api().fetch({with: 'requirements', order_by: 'name'});
            this.$store.$db().model("sampleTestTypes").api().fetch();
            this.$store.$db().model("sampleCertTypeCategories").api().fetch();
            this.$store.$db().model("sampleFlagTypes").api().fetch();
            this.$firestore.collection("Configs").doc("Belit").get().then(doc => {
              if (doc.exists) {
                let data = doc.data();
                this.$store.commit('setFilteredFlags', data.filtered_flags || data.manifest_filtered_flags || []);
                this.$store.commit('setFilteredTestTypes', data.filtered_test_types || []);
              }
            });
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    let user = firebase.auth().currentUser;
                    this.$store.commit('id', user.uid);
                    this.$store.commit('email', user.email);
                    this.$store.commit('name', user.displayName);
                    this.$store.commit('picture', user.photoURL);
                    this.drawer = true
                  // if(this.$store.getters.id){
                    this.checkRouteNotifications();
                  // }
                  let fbUser = this.$firestore.collection('users').doc(user.uid);
                  fbUser.get().then(doc => {
                    if(doc.exists){
                      this.$store.commit('setupUser', doc)
                    }else{
                      doc.ref.set({
                        uid: user.uid,
                        name: user.displayName,
                        email: user.email,
                        reason: false,
                        logged_in: true,
                        keep_alive: true,
                        updated: true,
                      }).finally(() => window.location.reload);

                    }
                  })
                }
            })
        },
        mounted(){
          setTimeout(() => {this.$store.state.dymo = new Label(dymo);}, 1000)
        },
        methods: {
            checkRouteNotifications(){
              for(let route of this.$router.options.routes){
                if(route.meta && route.meta.badge){
                  console.log(route, 'has badge')
                  let data = route.meta.badge;
                  this.$store.dispatch(data.dispatch);
                }
              }
            },
            linkify(view) {
                this.$router.replace(view)
            },
            customerSelected(selectedCustomerObject) {
                this.selectedCustomer = selectedCustomerObject
                this.drawer = false
            },
            googleLogOut() {
                firebase.auth().signOut().then(() => {
                    this.$store.commit('id',null);
                    this.$store.commit('email',null);
                    this.$store.commit('name',null);
                    this.$store.commit('given_name',null);
                    this.$store.commit('family_name',null);
                    this.$store.commit('picture',null);
                    this.drawer = false
                    this.$router.replace('login')
                })
            },
        }
    }
</script>
<style>
    [v-cloak] {
        display: none;
    }
</style>
